// extracted by mini-css-extract-plugin
module.exports = {"buttonCheckBox":"classes_buttonCheckBox__JQQ9H","typoResalt":"classes_typoResalt__2WZEO","typoNormal":"classes_typoNormal__1hLkH"};